import { render, staticRenderFns } from "./TransactionDetailsDialog.vue?vue&type=template&id=673d0870&scoped=true"
import script from "./TransactionDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailsDialog.vue?vue&type=style&index=0&id=673d0870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d0870",
  null
  
)

export default component.exports